import { Component} from '@angular/core';

@Component({
  selector: 'app-spinninganimation',
  templateUrl: './spinningAnimation.component.html',
  styleUrls: ['./spinningAnimation.componant.scss'],
})

export class SpinningAnimationComponent {
  constructor() {
  }
}